import {
  ModalProps as MantineModalProps,
  Modal as MantineModal,
  ModalRootProps as MantineModalRootProps,
  ModalRoot as MantineModalRoot,
  ModalOverlayProps as MantineModalOverlayProps,
  ModalOverlay as MantineModalOverlay,
  ModalContentProps as MantineModalContentProps,
  ModalContent as MantineModalContent,
  ModalBodyProps as MantineModalBodyProps,
  ModalBody as MantineModalBody,
  ModalHeaderProps as MantineModalHeaderProps,
  ModalHeader as MantineModalHeader,
  ModalTitleProps as MantineModalTitleProps,
  ModalTitle as MantineModalTitle,
  ModalCloseButtonProps as MantineModalCloseButtonProps,
  ModalCloseButton as MantineModalCloseButton,
} from '@mantine/core';

export type ModalProps = MantineModalProps;
export type ModalRootProps = MantineModalRootProps;
export type ModalOverlayProps = MantineModalOverlayProps;
export type ModalContentProps = MantineModalContentProps;
export type ModalBodyProps = MantineModalBodyProps;
export type ModalHeaderProps = MantineModalHeaderProps;
export type ModalTitleProps = MantineModalTitleProps;
export type ModalCloseButtonProps = MantineModalCloseButtonProps;

export const Modal = MantineModal;
Modal.displayName = 'Modal';

export const ModalRoot = MantineModalRoot;
ModalRoot.displayName = 'ModalRoot';

export const ModalOverlay = MantineModalOverlay;
ModalOverlay.displayName = 'ModalOverlay';

export const ModalContent = MantineModalContent;
ModalContent.displayName = 'ModalContent';

export const ModalBody = MantineModalBody;
ModalBody.displayName = 'ModalBody';

export const ModalHeader = MantineModalHeader;
ModalHeader.displayName = 'ModalHeader';

export const ModalTitle = MantineModalTitle;
ModalTitle.displayName = 'ModalTitle';

export const ModalCloseButton = MantineModalCloseButton;
ModalCloseButton.displayName = 'ModalCloseButton';
